import React from 'react';
import './SelectedFilters.css';

const SelectedFilters = ({ 
  selectedCategory, 
  selectedSubCategories = [], 
  onRemoveCategory,
  onRemoveSubCategory,
  onClearAll 
}) => {
  const hasFilters = selectedCategory || selectedSubCategories.length > 0;

  if (!hasFilters) {
    return null;
  }

  return (
    <div className="selected-filters">
      <div className="filter-pills">
        {selectedCategory && (
          <div className="filter-pill category-pill">
            <span className="pill-text">{selectedCategory}</span>
            <button 
              className="remove-pill"
              onClick={() => onRemoveCategory()}
              aria-label={`Remove ${selectedCategory} filter`}
            >
              ×
            </button>
          </div>
        )}
        
        {selectedSubCategories.map(subCategory => (
          <div key={subCategory} className="filter-pill subcategory-pill">
            <span className="pill-text">{subCategory}</span>
            <button 
              className="remove-pill"
              onClick={() => onRemoveSubCategory(subCategory)}
              aria-label={`Remove ${subCategory} filter`}
            >
              ×
            </button>
          </div>
        ))}
      </div>
      
      <button 
        className="clear-all-filters"
        onClick={onClearAll}
        aria-label="Clear all filters"
      >
        Clear All
      </button>
    </div>
  );
};

export default SelectedFilters;
